import React, { useState } from 'react'
import classNames from 'classnames'
import { CheckboxInputProps } from './CheckboxInput.d'

const CheckboxInput = ({
  id,
  label,
  name,
  stacked,
  onChange,
  checked,
  variation,
  region,
  textLeft
}: CheckboxInputProps) => {
  const defaultChecked = checked
  const [isChecked, setIsChecked] = useState(defaultChecked)

  const containerClassNames = classNames({
    'font-calibre text-xs': variation === 'default',
    'flex flex-row items-start brand2': variation === 'default' && stacked,
    'inline-flex flex-row brand2 mt-3': variation === 'default' && !stacked,
    block: variation === 'web' && stacked,
    'inline-block': variation === 'web' && !stacked
  })

  const textClassNames = classNames({
    'text-center [@media(min-width:992px)]:text-left': !textLeft,
    'text-left': textLeft
  })

  const handleInputChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked((prev) => !prev)
    if (typeof onChange === 'function') {
      onChange(ev)
    }
  }

  return (
    <>
      <div className={`${textClassNames} w-full text-[#666] text-[14px]`}>
        By submitting this form, you acknowledge that your information will be
        processed according to{' '}
        <a
          className='underline'
          href={'/' + region.toLowerCase() + '/privacy/'}
        >
          Toast’s privacy statement
        </a>
        .
      </div>
      <div className={containerClassNames}>
        <input
          checked={isChecked}
          className='mr-1 w-[50px] h-[50px] [@media(min-width:480px)]:w-[35px] [@media(min-width:480px)]:h-[35px] [@media(min-width:635px)]:w-[25px] [@media(min-width:635px)]:h-[25px] [@media(min-width:992px)]:w-[35px] [@media(min-width:992px)]:h-[35px]'
          id={id}
          name={name}
          onChange={handleInputChange}
          type='checkbox'
          value={isChecked ? 'true' : 'false'}
        />
        <label
          className={`$textClassNames} text-[14px] text-[#666] relative top-[-10px] [@media(min-width:580px)]:top-[-17px] [@media(min-width:800px)]:top-[-19px] [@media(min-width:992px)]:top-[-16px] font-['Source_Sans_Pro',sans-serif] pt-5`}
          htmlFor={id}
        >
          {label}
        </label>
      </div>
    </>
  )
}

export default CheckboxInput
